import { ComponentType, PropsWithChildren, ReactNode } from 'react';

import { RiSearchLine as Search } from '@remixicon/react';
import classNames from 'classnames';

import { Link, Text } from '@spotify-internal/encore-web';

import styles from './ListEmptyState.module.css';

export type ListEmptyStateProps = PropsWithChildren<{
  className?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  supportSnippet?: ReactNode;
  minimal?: boolean;
  icon?: ComponentType<{ className?: string }>;
  illustration?: ReactNode;
}>;

export const ListEmptyState = ({
  className,
  title,
  description,
  actions,
  minimal,
  supportSnippet = (
    <span>
      Not the results you expected?{' '}
      <Link href="mailto:confidence@spotify.com" target="_blank" data-track-source-anchor="e16a9ef593">
        Contact support
      </Link>
      .
    </span>
  ),
  icon: Icon = Search,
  illustration,
  children,
}: ListEmptyStateProps) => (
  <div className={classNames(styles.container, className)}>
    <div className={styles.content}>
      {!minimal &&
        (illustration ?? (
          <div className={styles.iconWrapper} aria-hidden="true">
            <Icon className={styles.icon} />
          </div>
        ))}
      <Text
        as={minimal ? 'p' : 'h4'}
        variant={minimal ? 'bodyMedium' : 'titleMedium'}
      >
        {title}
      </Text>
      {description && (
        <Text as="div" variant="bodyMedium" semanticColor="textSubdued">
          {description}
        </Text>
      )}
      {actions && <div className={styles.actions}>{actions}</div>}
      {Boolean(supportSnippet) && !minimal && (
        <Text
          as="div"
          variant="marginal"
          semanticColor="textSubdued"
          className={styles.contactSupportSnippet}
        >
          {supportSnippet}
        </Text>
      )}
    </div>
    {children}
  </div>
);
